import React, { useEffect, useState } from 'react';
import {
  getTheme,
  IIconProps,
  IStackItemStyles,
  IStackStyles,
  IStackTokens,
  Label,
  Link,
  mergeStyleSets,
  Text,
  TextField,
} from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { uPrinceTheme } from '../../../../../theme';
import { Invoice, InvoiceValidationMessage } from '../../../../types/invoice';


const theme = getTheme();

const iconButtonStyles = {
  root: {
    color: uPrinceTheme.palette.themePrimary,
  },
  rootHovered: {
    color: theme.palette.neutralDark,
  },
};

// Styles definition
const stackStyles: IStackStyles = {
  root: {
    padding: 0,
    marginBottom: 10,
  },
};
const stackItemStyles: IStackItemStyles = {
  root: {
    display: 'flex',
    height: 50,
    width: 0,
    flexGrow: 1,
  },
};

// Tokens definition
const stackTokens: IStackTokens = {
  childrenGap: 10,
  padding: 10,
};


const classNames = mergeStyleSets({
  fullWidth: {
    width: '100%',
  },
  labelRightWrapper: {
    textAlign: 'end',
    selectors: {
      '@media(max-width: 1100px)': {
        textAlign: 'start',
      },
    },
  },
  actionButton: {
    color: uPrinceTheme.palette.themePrimary,
    cursor: 'pointer',
  },
  bigScreenTree: {
    marginBottom: 30,
    height: '30vh',
  },
  smallScreenTree: {
    marginBottom: 30,
    height: '56vh',
  },
  textEditor: {
    height: window.innerWidth <= 1280 ? '50vh' : '25vh',
  },
  customerLabel: {
    paddingTop: 0,
    paddingBottom: 0,
  },
});

const stackFooterBarItemStyles: IStackItemStyles = {
  root: {
    height: 45,
  },
};
const saveIcon: IIconProps = { iconName: 'Save', styles: iconButtonStyles };


const CustomerInformation = (props: {
  isEdit: boolean,
  dropDownOptions: any,
  formData: Invoice;
  saveFormData: () => void;
  handleFormChange: (
    progressStatement: Invoice,
    save: boolean,
  ) => void;
  validationMessages: InvoiceValidationMessage;
}) => {
  const { t } = useTranslation();
  // const options: IChoiceGroupOption[] = [
  //   { key: '0', text: t('inScope"'),checked:true},
  //   { key: '1', text: t('outofScope"') ,styles:{field: { marginLeft: "15px"}}},
  // ];
  const customerDetails = {
    customerName: null,
    contactPersonName: null,
    contactPersonEmail: null,
    purchaseOrderNumber: null,
  };
  const [customer, setCustomer]: any = useState(customerDetails);

  useEffect(() => {
    if (props.dropDownOptions.customer) {
      setCustomer(props.dropDownOptions.customer);
    }
  }, [props.dropDownOptions]);
  return (
    <div className={'document-pane-card'}>

      <div className={'card-header'}>
        <Link href="#" id="invoice-customer-information">
          <Label>2. {t('customerInformation')} </Label>
        </Link>
      </div>

      <div className={'card-body'}>
        <div className="proj-detail-content inner">

          <div className="marginTop">
            <div className={'ms-Grid'} style={{ width: '100%', height: '100%', padding: 16 }}>
              <div className="ms-Grid-row">
                <div className={`ms-Grid-col ms-sm12 ms-md12 padding-left-0`}>
                  <div className={`${classNames.fullWidth}`} style={{ fontSize: 10 }}>
                    <Label
                      className={`${classNames.customerLabel}`}>{t('customerName')} : <Text> {customer.customerName} </Text></Label>
                    <Label
                      className={`${classNames.customerLabel}`}>{t('customerContactPersonName')} : <Text>  {customer.contactPersonName}</Text></Label>
                    <Label
                      className={`${classNames.customerLabel}`}>{t('customerContactPersonEmail')} : <Text>  {customer.contactPersonEmail} </Text></Label>
                  </div>
                </div>
              </div>
              <div className="ms-Grid-row">
                <div className={`ms-Grid-col ms-sm12 ms-md6 padding-left-0`}>
                  <div className={`${classNames.fullWidth}`}>
                    <TextField
                      label={t('customerPurchaseordernumber')}
                      value={
                        props.formData.purchaseOrderNumber
                          ? props.formData.purchaseOrderNumber
                          : ''
                      }
                      // errorMessage={
                      //   props.validationMessages.nameErrorMsg
                      //     ? props.validationMessages.nameErrorMsg
                      //     : ''
                      // }
                      onChange={(event, value) => {
                        if (value) {
                          props.formData.purchaseOrderNumber = value;
                          //props.validationMessages.nameErrorMsg="";
                          setCustomer((prevState: any) => ({
                            ...prevState,
                            purchaseOrderNumber: value,
                          }));
                        } else {
                          props.formData.purchaseOrderNumber = null;
                          setCustomer((prevState: any) => ({
                            ...prevState,
                            purchaseOrderNumber: null,
                          }));
                        }
                        props.handleFormChange(
                          props.formData,
                          true,
                        );
                      }}
                      disabled={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div className={'card-footer'}>

      </div>

    </div>
  );
};


export default CustomerInformation;
